export class Merchant {
  price: number;
  buyerInfo: {
    city: string,
    district: string,
    town: string,
  };
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/shared/classes/merchant.model.ts